module.exports = __webpack_public_path__ + "static/media/twitter.ce897e80.svg";